
  import {
      linkTypeMap,
      createClient as createClientOriginal,
      generateGraphqlOperation,
      assertSameVersion,
  } from '@gqlts/runtime'
  import types from './types.esm'
  var typeMap = linkTypeMap(types)
  export * from './guards.esm'

  export var version = "3.4.0"
  assertSameVersion(version)

  export var createClient = 
function(options) {
    options = options || {}
    var optionsCopy = {
      url: "https://hasura.cloud.shaggaga.ly/v1/graphql",
      queryRoot: typeMap.Query,
      mutationRoot: typeMap.Mutation,
      subscriptionRoot: typeMap.Subscription,
    }
    for (var name in options) {
      optionsCopy[name] = options[name];
    }
    return createClientOriginal(optionsCopy)
}

  export const enumaddressesConstraint = {
  addresses_pkey: 'addresses_pkey'
}

export const enumaddressesSelectColumn = {
  buyer_id: 'buyer_id',
  city: 'city',
  description: 'description',
  id: 'id',
  location: 'location',
  name: 'name',
  seller_id: 'seller_id',
  undefined_buyer_id: 'undefined_buyer_id',
  verification_status: 'verification_status'
}

export const enumaddressesUpdateColumn = {
  description: 'description',
  location: 'location'
}

export const enumbuyersSelectColumn = {
  has_whatsapp: 'has_whatsapp',
  id: 'id',
  image_id: 'image_id',
  name: 'name',
  phone_number: 'phone_number'
}

export const enumcursorOrdering = {
  ASC: 'ASC',
  DESC: 'DESC'
}

export const enumdriversLocationsSelectColumn = {
  altitude: 'altitude',
  altitude_accuracy: 'altitude_accuracy',
  bearing_string: 'bearing_string',
  date_created: 'date_created',
  date_updated: 'date_updated',
  driver_id: 'driver_id',
  id: 'id',
  latitude: 'latitude',
  location: 'location',
  location_accuracy_radius: 'location_accuracy_radius',
  location_recorded_time_unix: 'location_recorded_time_unix',
  longitude: 'longitude',
  route_id: 'route_id',
  simulated: 'simulated',
  speed: 'speed'
}

export const enumdriversSelectColumn = {
  has_whatsapp: 'has_whatsapp',
  id: 'id',
  image_id: 'image_id',
  name: 'name',
  phone_number: 'phone_number'
}

export const enumenvVariablesSelectColumn = {
  id: 'id',
  key: 'key',
  value: 'value',
  value_type: 'value_type'
}

export const enumfoodCategoriesProductsConstraint = {
  food_categories_products_pkey: 'food_categories_products_pkey'
}

export const enumfoodCategoriesProductsSelectColumn = {
  food_categories_id: 'food_categories_id',
  id: 'id',
  products_id: 'products_id'
}

export const enumfoodCategoriesProductsUpdateColumn = {
  _PLACEHOLDER: '_PLACEHOLDER'
}

export const enumfoodCategoriesSelectColumn = {
  id: 'id',
  name: 'name'
}

export const enummessagesConstraint = {
  messages_pkey: 'messages_pkey'
}

export const enummessagesFromConstraint = {
  messages_from_message_id_key: 'messages_from_message_id_key',
  messages_from_pkey: 'messages_from_pkey'
}

export const enummessagesFromSelectColumn = {
  buyer_id: 'buyer_id',
  date_created: 'date_created',
  date_updated: 'date_updated',
  driver_id: 'driver_id',
  id: 'id',
  message_id: 'message_id',
  operator_id: 'operator_id',
  seller_id: 'seller_id',
  undefined_buyer_id: 'undefined_buyer_id'
}

export const enummessagesFromUpdateColumn = {
  _PLACEHOLDER: '_PLACEHOLDER'
}

export const enummessagesSelectColumn = {
  attachment: 'attachment',
  date_created: 'date_created',
  date_updated: 'date_updated',
  id: 'id',
  location_stamp: 'location_stamp',
  read_timestamp: 'read_timestamp',
  shipment_id: 'shipment_id',
  text: 'text'
}

export const enummessagesToConstraint = {
  messages_to_message_id_key: 'messages_to_message_id_key',
  messages_to_pkey: 'messages_to_pkey'
}

export const enummessagesToSelectColumn = {
  buyer_id: 'buyer_id',
  date_created: 'date_created',
  date_updated: 'date_updated',
  driver_id: 'driver_id',
  id: 'id',
  message_id: 'message_id',
  operator_id: 'operator_id',
  seller_id: 'seller_id',
  undefined_buyer_id: 'undefined_buyer_id'
}

export const enummessagesToUpdateColumn = {
  _PLACEHOLDER: '_PLACEHOLDER'
}

export const enummessagesUpdateColumn = {
  read_timestamp: 'read_timestamp'
}

export const enumoperatorsSelectColumn = {
  id: 'id',
  image_id: 'image_id',
  name: 'name'
}

export const enumorderBy = {
  asc: 'asc',
  asc_nulls_first: 'asc_nulls_first',
  asc_nulls_last: 'asc_nulls_last',
  desc: 'desc',
  desc_nulls_first: 'desc_nulls_first',
  desc_nulls_last: 'desc_nulls_last'
}

export const enumproductsConstraint = {
  products_pkey: 'products_pkey'
}

export const enumproductsExtrasConstraint = {
  products_extras_pkey: 'products_extras_pkey'
}

export const enumproductsExtrasSelectColumn = {
  date_created: 'date_created',
  date_updated: 'date_updated',
  description: 'description',
  id: 'id',
  is_available: 'is_available',
  name: 'name',
  price: 'price',
  product_id: 'product_id'
}

export const enumproductsExtrasUpdateColumn = {
  date_updated: 'date_updated',
  description: 'description',
  is_available: 'is_available',
  is_deleted: 'is_deleted',
  name: 'name',
  price: 'price'
}

export const enumproductsSelectColumn = {
  date_created: 'date_created',
  date_updated: 'date_updated',
  description: 'description',
  dimensions_cm: 'dimensions_cm',
  extra_images_ids: 'extra_images_ids',
  id: 'id',
  image_id: 'image_id',
  is_available: 'is_available',
  is_deleted: 'is_deleted',
  is_public: 'is_public',
  is_retail: 'is_retail',
  min_quantity: 'min_quantity',
  name: 'name',
  price: 'price',
  seller_id: 'seller_id',
  standard_size_id: 'standard_size_id',
  volume_cm3: 'volume_cm3'
}

export const enumproductsSelectColumnProductsAggregateBoolExpBoolAndArgumentsColumns = {
  is_available: 'is_available',
  is_deleted: 'is_deleted',
  is_public: 'is_public',
  is_retail: 'is_retail'
}

export const enumproductsSelectColumnProductsAggregateBoolExpBoolOrArgumentsColumns = {
  is_available: 'is_available',
  is_deleted: 'is_deleted',
  is_public: 'is_public',
  is_retail: 'is_retail'
}

export const enumproductsUpdateColumn = {
  date_updated: 'date_updated',
  description: 'description',
  dimensions_cm: 'dimensions_cm',
  extra_images_ids: 'extra_images_ids',
  image_id: 'image_id',
  is_available: 'is_available',
  is_deleted: 'is_deleted',
  is_public: 'is_public',
  min_quantity: 'min_quantity',
  name: 'name',
  price: 'price',
  standard_size_id: 'standard_size_id'
}

export const enumsellerProductsStandardSizesConstraint = {
  seller_products_standard_sizes_pkey: 'seller_products_standard_sizes_pkey'
}

export const enumsellerProductsStandardSizesSelectColumn = {
  date_created: 'date_created',
  date_deleted: 'date_deleted',
  date_updated: 'date_updated',
  height: 'height',
  id: 'id',
  length: 'length',
  name: 'name',
  seller_id: 'seller_id',
  volume_cm3: 'volume_cm3',
  width: 'width'
}

export const enumsellerProductsStandardSizesUpdateColumn = {
  _PLACEHOLDER: '_PLACEHOLDER'
}

export const enumsellerReviewsSelectColumn = {
  body: 'body',
  buyer_id: 'buyer_id',
  date_created: 'date_created',
  id: 'id',
  rating: 'rating',
  seller_id: 'seller_id',
  seller_reply: 'seller_reply',
  seller_reply_at: 'seller_reply_at',
  shipment_id: 'shipment_id',
  undefined_buyer_id: 'undefined_buyer_id'
}

export const enumsellersPayoutsReceiptsOutSelectColumn = {
  date_created: 'date_created',
  date_updated: 'date_updated',
  id: 'id',
  invoice_amount: 'invoice_amount',
  issued_by: 'issued_by',
  paid_by: 'paid_by',
  payment_timestamp: 'payment_timestamp',
  receipt_number: 'receipt_number',
  seller_id: 'seller_id'
}

export const enumsellersSelectColumn = {
  company_free_shipping_threshold: 'company_free_shipping_threshold',
  date_created: 'date_created',
  date_updated: 'date_updated',
  description: 'description',
  extra_images_ids: 'extra_images_ids',
  id: 'id',
  image_id: 'image_id',
  is_available: 'is_available',
  is_online_payments_enabled: 'is_online_payments_enabled',
  min_shipment_products_cost: 'min_shipment_products_cost',
  name: 'name',
  ops_has_whatsapp: 'ops_has_whatsapp',
  ops_phone_number: 'ops_phone_number',
  pickup_time_windows_utc: 'pickup_time_windows_utc',
  public_has_whatsapp: 'public_has_whatsapp',
  public_phone_number: 'public_phone_number',
  seller_free_shipping_threshold: 'seller_free_shipping_threshold',
  seller_number: 'seller_number',
  shipping_geofence: 'shipping_geofence'
}

export const enumsellersUsersSelectColumn = {
  has_whatsapp: 'has_whatsapp',
  id: 'id',
  mobile_device_token: 'mobile_device_token',
  name: 'name',
  phone_number: 'phone_number',
  seller_id: 'seller_id',
  web_device_token: 'web_device_token'
}

export const enumshipmentProductItemExtrasConstraint = {
  shipment_product_extras_pkey: 'shipment_product_extras_pkey'
}

export const enumshipmentProductItemExtrasSelectColumn = {
  calculated_price: 'calculated_price',
  id: 'id',
  product_extra_id: 'product_extra_id',
  quantity: 'quantity',
  shipment_product_item_id: 'shipment_product_item_id'
}

export const enumshipmentProductItemExtrasUpdateColumn = {
  quantity: 'quantity'
}

export const enumshipmentProductsItemsConstraint = {
  shipment_products_pkey: 'shipment_products_pkey'
}

export const enumshipmentProductsItemsSelectColumn = {
  calculated_price: 'calculated_price',
  calculated_seller_price: 'calculated_seller_price',
  date_created: 'date_created',
  date_updated: 'date_updated',
  id: 'id',
  product_id: 'product_id',
  quantity: 'quantity',
  shipment_id: 'shipment_id'
}

export const enumshipmentProductsItemsUpdateColumn = {
  is_deleted: 'is_deleted',
  quantity: 'quantity'
}

export const enumshipmentsBoxesConstraint = {
  shipments_boxes_pkey: 'shipments_boxes_pkey'
}

export const enumshipmentsBoxesSelectColumn = {
  date_created: 'date_created',
  date_updated: 'date_updated',
  description: 'description',
  dimensions_cm: 'dimensions_cm',
  id: 'id',
  name: 'name',
  price: 'price',
  quantity: 'quantity',
  shipment_id: 'shipment_id',
  standard_size_id: 'standard_size_id',
  volume_cm3: 'volume_cm3'
}

export const enumshipmentsBoxesUpdateColumn = {
  description: 'description',
  is_deleted: 'is_deleted',
  name: 'name',
  price: 'price',
  quantity: 'quantity'
}

export const enumshipmentsNotesSelectColumn = {
  created_at: 'created_at',
  id: 'id',
  note: 'note',
  role: 'role',
  shipment_id: 'shipment_id',
  type: 'type',
  user_id: 'user_id'
}

export const enumshipmentsPaymentsSelectColumn = {
  amount: 'amount',
  date_created: 'date_created',
  id: 'id',
  method: 'method',
  notes: 'notes',
  payment_gateway: 'payment_gateway',
  payment_reference: 'payment_reference',
  refunds_payment_id: 'refunds_payment_id',
  shipment_id: 'shipment_id',
  status: 'status',
  transaction_type: 'transaction_type'
}

export const enumshipmentsRoutesStepsSelectColumn = {
  address_id: 'address_id',
  date_created: 'date_created',
  date_updated: 'date_updated',
  eta: 'eta',
  id: 'id',
  status: 'status',
  type: 'type'
}

export const enumshipmentsRoutesStepsShipmentsSelectColumn = {
  completion_timestamp: 'completion_timestamp',
  date_created: 'date_created',
  date_updated: 'date_updated',
  id: 'id',
  is_completed: 'is_completed',
  is_noshow: 'is_noshow',
  is_reschedule: 'is_reschedule',
  shipment_id: 'shipment_id',
  shipments_routes_step_id: 'shipments_routes_step_id',
  shipping_cost: 'shipping_cost',
  type: 'type'
}

export const enumshipmentsSelectColumn = {
  allowed_payment_methods: 'allowed_payment_methods',
  amount_paid: 'amount_paid',
  assigned_driver_id: 'assigned_driver_id',
  base_shipping_cost: 'base_shipping_cost',
  buyer_id: 'buyer_id',
  cancellation_object: 'cancellation_object',
  company_discount: 'company_discount',
  date_created: 'date_created',
  date_updated: 'date_updated',
  delivered_timestamp: 'delivered_timestamp',
  destination_address_id: 'destination_address_id',
  dynamic_shipping_cost: 'dynamic_shipping_cost',
  eta: 'eta',
  eta_updated: 'eta_updated',
  id: 'id',
  is_active: 'is_active',
  is_company_free_shipping: 'is_company_free_shipping',
  is_seller_free_shipping: 'is_seller_free_shipping',
  payment_status: 'payment_status',
  preferred_delivery_time_windows_utc: 'preferred_delivery_time_windows_utc',
  products_cost: 'products_cost',
  products_cost_seller: 'products_cost_seller',
  products_paid_in_advance: 'products_paid_in_advance',
  ready_time: 'ready_time',
  required_amount: 'required_amount',
  returned_timestamp: 'returned_timestamp',
  seller_discount: 'seller_discount',
  seller_id: 'seller_id',
  seller_payout_receipt_out_id: 'seller_payout_receipt_out_id',
  shipment_number: 'shipment_number',
  shipping_cost: 'shipping_cost',
  status: 'status',
  total_volume_cm3: 'total_volume_cm3',
  tracking_encryption_string: 'tracking_encryption_string',
  undefined_buyer_id: 'undefined_buyer_id'
}

export const enumshipmentsSelectColumnShipmentsAggregateBoolExpBoolAndArgumentsColumns = {
  is_active: 'is_active',
  is_company_free_shipping: 'is_company_free_shipping',
  is_seller_free_shipping: 'is_seller_free_shipping',
  products_paid_in_advance: 'products_paid_in_advance'
}

export const enumshipmentsSelectColumnShipmentsAggregateBoolExpBoolOrArgumentsColumns = {
  is_active: 'is_active',
  is_company_free_shipping: 'is_company_free_shipping',
  is_seller_free_shipping: 'is_seller_free_shipping',
  products_paid_in_advance: 'products_paid_in_advance'
}

export const enumshippingCostPerCitySelectColumn = {
  base_cost: 'base_cost',
  city: 'city',
  cm3_multiplier: 'cm3_multiplier',
  date_created: 'date_created',
  date_updated: 'date_updated',
  geo_fence: 'geo_fence',
  id: 'id',
  minimum_cost: 'minimum_cost'
}

export const enumundefinedBuyersConstraint = {
  undefined_buyers_pkey: 'undefined_buyers_pkey'
}

export const enumundefinedBuyersSelectColumn = {
  date_created: 'date_created',
  date_updated: 'date_updated',
  has_whatsapp: 'has_whatsapp',
  id: 'id',
  name: 'name',
  phone_number: 'phone_number'
}

export const enumundefinedBuyersUpdateColumn = {
  _PLACEHOLDER: '_PLACEHOLDER'
}


  export var generateQueryOp = function(fields) {
    return generateGraphqlOperation('query', typeMap.Query, fields)
  }
  export var generateMutationOp = function(fields) {
    return generateGraphqlOperation('mutation', typeMap.Mutation, fields)
  }
  export var generateSubscriptionOp = function(fields) {
    return generateGraphqlOperation('subscription', typeMap.Subscription, fields)
  }
  export var everything = {
    __scalar: true
  }
  